var Other = [{ // 登录
    path: '/login',
    name: 'login',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/login/login'),
  },
  { // 注册
    path: '/register',
    name: 'register',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/login/register'),
  },
  { // 修改密码
    path: '/changePassword',
    name: 'changePassword',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/login/changePassword'),
  },
  { // 第三方登录
    path: '/otherLogin',
    name: 'otherLogin',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/login/otherLogin'),
  },
  { // 个人中心
    path: '/user',
    name: 'user',

    component: () => import('@/views/user/user'),
    children: [{ // 个人中心首页
        path: 'userIndex',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/userIndex'),
        name: 'userIndex',
        alias: '/user'
      },
      { // 账户管理
        path: 'account',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/account'),
        name: 'account',
      },
      { // 订单管理
        path: 'orderManage',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/orderManage'),
        name: 'orderManage',
      },
      { // 订单详情
        path: 'orderManage/detail',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/orderDetail'),
        name: 'orderDetail',
      },
      { // 订单评价
        path: 'orderManage/evaluate',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/orderEvaluate'),
        name: 'orderEvaluate',
      },
      { // 消息中心
        path: 'notice',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/notice'),
        name: 'notice',
      },
      { // 消息中心/详情
        path: 'notice/detail',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/noticeDetail'),
        name: 'noticeDetail',
      },
      { // 我的游记
        path: 'myNote',
        meta: {
          'isFoot': false
        },
        component: () => import('@/views/user/myNote'),
        name: 'myNote',
      },

    ]
  },
  { // 预定讲解列表
    path: '/explanation',
    meta: {
      'isFoot': true
    },
    component: () => import('@/views/shopping/explanation'),
    name: 'explanation',
  },
  { // 餐饮列表
    path: '/restaurant',
    meta: {
      'isFoot': true
    },
    component: () => import('@/views/shopping/restaurant'),
    name: 'restaurant',
  },
  { // 特产列表
    path: '/specialProduct',
    meta: {
      'isFoot': true
    },
    component: () => import('@/views/shopping/specialProduct'),
    name: 'specialProduct',
  },
  { // 特产列表
    path: '/specialProductDetail',
    meta: {
      'isFoot': true
    },
    component: () => import('@/views/shopping/specialProductDetail'),
    name: 'specialProductDetail',
  },
  { // 酒店列表
    path: '/hotel',
    meta: {
      'isFoot': true
    },
    component: () => import('@/views/shopping/hotel'),
    name: 'hotel',
  },
  { // 确认订单
    path: '/checkOrder',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/shopping/checkOrder'),
    name: 'checkOrder',
  },
  { // 在线支付
    path: '/payment',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/shopping/payment'),
    name: 'payment',
  },
  { // 支付完成 成功
    path: '/paymentCompleted',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/shopping/paymentCompleted'),
    name: 'paymentCompleted',
  },
  { // 支付完成  失败
    path: '/paymentFail',
    meta: {
      'isFoot': false
    },
    component: () => import('@/views/shopping/paymentFail'),
    name: 'paymentFail',
  },
  { // 游记攻略 -详情
    path: '/travelNotesDetail',
    meta: {
      'isFoot': true
    },
    component: () => import('@/views/travelNotes/detail'),
    name: 'travelNotesDetail',
  },
  { // 游记攻略 -编辑
    path: '/travelNotes/edit',
    meta: {
      'isFoot': true
    },
    component: () => import('@/views/travelNotes/edit'),
    name: 'travelNotesEdit',
  },
]

export {
  Other
}



// WEBPACK FOOTER //
// ./src/router/other.js